var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 129,
    viewBox: "0 0 141 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.930328H136C138.347 0.930328 140.25 2.83312 140.25 5.18033V124C140.25 126.347 138.347 128.25 136 128.25H43.7059C41.3587 128.25 39.4559 126.347 39.4559 124V62.8339C39.4559 59.6583 36.8815 57.0839 33.7059 57.0839H4.99999C2.65279 57.0839 0.75 55.1811 0.75 52.8339V5.18033C0.75 2.83312 2.65279 0.930328 5 0.930328Z",
    fill: "#10B981",
    fillOpacity: 0.7,
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3471 78.1307L74.9096 69.6932L83.3471 61.2557V78.1307ZM80.7619 71.2273V68.1591H106.302V71.2273H80.7619ZM103.319 71.2273V53.3296H106.387V71.2273H103.319Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterGreen);
export default __webpack_public_path__ + "static/media/EnterGreen.5782e21b5837ef3a18d04509fb2df512.svg";
export { ForwardRef as ReactComponent };